import { useQuery } from '@tanstack/react-query';
import { FirebaseAuth } from 'services/FirebaseService/auth';

interface UseIsSuperAdminOptions {
  enabled?: boolean;
}

export function useIsSuperAdmin({
  enabled = true,
}: UseIsSuperAdminOptions = {}) {
  const userUID = FirebaseAuth.getUserId();

  const { data: isSuperAdmin = false, isLoading } = useQuery({
    queryKey: ['isSuperAdmin', userUID],
    queryFn: () => FirebaseAuth.isSuperAdmin(),
    staleTime: Infinity,
    enabled: enabled && Boolean(userUID),
  });

  return { isSuperAdmin, isLoading };
}
